import { render, staticRenderFns } from "./ColleagueDashboard.vue?vue&type=template&id=7c6e4587"
import script from "./ColleagueDashboard.vue?vue&type=script&lang=js"
export * from "./ColleagueDashboard.vue?vue&type=script&lang=js"
import style0 from "./ColleagueDashboard.vue?vue&type=style&index=0&id=7c6e4587&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports